export enum UserRole  {
  READER = "reader",
  WRITER = "writer",
  OWNER = "owner"
}

export interface User {
  email: string;
  uid: string;
  role: UserRole;
}

/* export interface User {
    uid: string;
    email: string;
    role: string;
} */
